import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { ThemeProvider } from "./context/ThemeContext";
import { I18nProvider } from "./i18n";
import { Toaster } from "sonner";
import Layout from "./components/layout/Layout";
import Landing from "./pages/Landing";
import Home from "./pages/Home";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Forums from "./pages/Forums";
import Board from "./pages/Board";
import Topic from "./pages/Topic";
import Profile from "./pages/Profile";
import FaceitProfile from "./pages/FaceitProfile";
import VipLoadout from "./pages/VipLoadout";
import Members from "./pages/Members";
import Leaderboard from "./pages/Leaderboard";
import Admin from "./pages/Admin";
import Donate from "./pages/Donate";
import Messages from "./pages/Messages";
import SsoCallback from "./pages/SsoCallback";
import IdgPage from "./pages/IdgPage";
import Marketplace from "./pages/Marketplace";
import IDGAppearanceLoader from "./components/IDGAppearanceLoader";
import IDGPushNotificationManager from "./components/IDGPushNotificationManager";
import Clans from "./pages/Clans";
import ClanProfile from "./pages/ClanProfile";
import AdminClans from "./pages/AdminClans";
import Servere from "./pages/Servere";
import Play from "./pages/Play";
import News from "./pages/News";
import Tournaments from "./pages/Tournaments";
import Downloads from "./pages/Downloads";
import { WidgetBuilderProvider } from "./context/WidgetBuilderContext";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ThemeProvider>
          <AuthProvider>
            <I18nProvider>
              <IDGAppearanceLoader />
              <IDGPushNotificationManager />
              <Toaster theme="dark" position="top-right" richColors />
              <WidgetBuilderProvider>
                <Layout>
                  <Routes>
                    <Route path="/" element={<Landing />} />
                    <Route path="/dashboard" element={<Home />} />
                    <Route path="/login" element={<Login />} />
                    <Route path="/register" element={<Register />} />
                    <Route path="/forums" element={<Forums />} />
                    <Route path="/forums/:boardId" element={<Board />} />
                    <Route path="/topic/:topicId" element={<Topic />} />
                    <Route path="/u/:username" element={<Profile />} />
                    <Route path="/esports/:username" element={<FaceitProfile />} />
                    <Route path="/faceit/:username" element={<FaceitProfile />} />
                    <Route path="/loadout" element={<VipLoadout />} />
                    <Route path="/vip" element={<VipLoadout />} />
                    <Route path="/members" element={<Members />} />
                    <Route path="/leaderboard" element={<Leaderboard />} />
                    <Route path="/admin" element={<Admin />} />
                    <Route path="/acp" element={<Admin />} />
                    <Route path="/admin/clans" element={<AdminClans />} />
                    <Route path="/donate" element={<Donate />} />
                    <Route path="/wallet" element={<Donate />} />
                    <Route path="/messages" element={<Messages />} />
                    <Route path="/messages/:threadId" element={<Messages />} />
                    <Route path="/auth/callback" element={<SsoCallback />} />
                    <Route path="/auth/:provider/callback" element={<SsoCallback />} />
                    <Route path="/p/:slug" element={<IdgPage />} />
                    <Route path="/marketplace" element={<Marketplace />} />
                    <Route path="/clans" element={<Clans />} />
                    <Route path="/clans/:id" element={<ClanProfile />} />
                    <Route path="/news" element={<News />} />
                    <Route path="/stiri" element={<News />} />
                    <Route path="/turnee" element={<Tournaments />} />
                    <Route path="/tournaments" element={<Tournaments />} />
                    <Route path="/matches" element={<Tournaments />} />
                    <Route path="/servere" element={<Servere />} />
                    <Route path="/servers" element={<Servere />} />
                    <Route path="/play" element={<Play />} />
                    <Route path="/downloads" element={<Downloads />} />
                    <Route path="/resurse" element={<Downloads />} />
                    <Route path="/download" element={<Downloads />} />
                  </Routes>
                </Layout>
              </WidgetBuilderProvider>
            </I18nProvider>
          </AuthProvider>
        </ThemeProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
